exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.topic{padding:5.5rem 0 0\n}\n@media screen and (min-width:1200px){\n.topic{padding:6.875rem 0 0\n}\n}\n@media screen and (min-width:1440px){\n.topic{padding:8.25rem 0 0\n}\n}\n@media screen and (min-width:1920px){\n.topic{padding:11rem 0 0\n}\n}\n@media screen and (min-width:2400px){\n.topic{padding:13.75rem 0 0\n}\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./public/js/components/Topic.vue
// module id = 641
// module chunks = 0